import React, { useCallback } from "react";
import { usePPTToastNotification } from "../components/PPTToastNotifications";

export const usePPTToasts = () => {
  const { openToast } = usePPTToastNotification();

  const showSuccessToast = useCallback(
    (message) => {
      openToast(message, "success");
    },
    [openToast],
  );

  const showErrorToast = useCallback(
    (message) => {
      openToast(message, "error");
    },
    [openToast],
  );

  return { showSuccessToast, showErrorToast };
};
